module.exports = __webpack_public_path__ + "static/media/lightbulb-dollar.81aaad8b.svg";